// extracted by mini-css-extract-plugin
export default {"list":"pagination_list__y2Rfw","pagin":"pagination_pagin__Dvbuw","thumb":"pagination_thumb__Xhc1f","item":"pagination_item__uOu4K","item_actived":"pagination_item_actived__YcE6i"};